import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { formatManwon } from '../../../utils/formatKRW';
import { InflationDataPoint } from '../InflationPage.hooks';

export interface InflationChartProps {
  yearlyData: InflationDataPoint[];
}

export function InflationChart({ yearlyData }: InflationChartProps) {
  return (
    <ResponsiveContainer width="100%" height={240}>
      <AreaChart data={yearlyData} margin={{ top: 8, right: 8, bottom: 0, left: 8 }}>
        <defs>
          <linearGradient id="realGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#ef4444" stopOpacity={0.3} />
            <stop offset="95%" stopColor="#ef4444" stopOpacity={0.05} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f0f0f0" />
        <XAxis dataKey="year" tickFormatter={(v) => `${v}년후`} axisLine={false} tickLine={false} />
        <YAxis tickFormatter={(v) => `${Math.round(v / 10000)}만`} width={60} axisLine={false} tickLine={false} />
        <Tooltip
          formatter={((v: number, name: string) => [formatManwon(v), name]) as any}
          labelFormatter={(v) => `${v}년 후`}
        />
        <Area type="monotone" dataKey="realExpense" name="물가 반영 월 생활비" stroke="#ef4444" fill="url(#realGradient)" />
        <Area type="monotone" dataKey="nominalExpense" name="현재 기준 월 생활비" stroke="#9ca3af" fill="rgba(156,163,175,0.1)" strokeDasharray="4 2" />
      </AreaChart>
    </ResponsiveContainer>
  );
}
